import React from 'react';
import moment from 'moment';
import { gMapKey } from 'core/constants';
import { withScriptjs, withGoogleMap, GoogleMap, Marker, DirectionsRenderer } from 'react-google-maps';

const defaultPostion = {
  lat: -34.6037239,
  lng: -58.3821802,
};

const INPUT_STYLE = {
  border: '1px solid transparent',
  width: '240px',
  height: '32px',
  marginTop: '10px',
  padding: '0 12px',
  borderRadius: '1px',
  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
  fontSize: '14px',
  outline: 'none',
  textOverflow: 'ellipses',
};

export default class extends React.Component {
  componentDidMount() {
    const DirectionsService = new GoogleMap.maps.DirectionsService();

    DirectionsService.route(
      {
        origin: new GoogleMap.maps.LatLng(this.props.salida.get('lat'), this.props.salida.get('lng')),
        destination: new GoogleMap.maps.LatLng(this.props.destino.get('lat'), this.props.destino.get('lng')),
        travelMode: GoogleMap.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === GoogleMap.maps.DirectionsStatus.OK) {
          this.setState({
            directions: result,
          });
        } else {
          console.error(`error fetching directions ${result}`);
        }
      },
    );
  }

  render() {
    return (
      <GettingStartedGoogleMap
        containerElement={this.props.containerElement}
        mapElement={this.props.mapElement}
        onMapLoad={this.props.onMapLoad}
        onPlacesChanged={this.handlePlacesChanged}
        loadingElement={<div style={{ height: '-webkit-fill-available' }} />}
        directions={this.props.directions}
        googleMapURL={`https://maps.googleapis.com/maps/api/js?libraries=places,geometry,drawing&key=${gMapKey}`}
      />
    );
  }
}

const GettingStartedGoogleMap = withScriptjs(
  withGoogleMap((props) => {
    let defCenter = null;
    if (props.marker) defCenter = props.marker;
    else defCenter = props.ubicacionParada && props.ubicacionParada.find((ubicacion) => !!ubicacion);
    return (
      <GoogleMap defaultZoom={props.defZoom || 14} center={defCenter || defaultPostion} defaultCenter={defCenter || defaultPostion} clickableIcons={false}>
        {props.directions && <DirectionsRenderer directions={props.directions} />}
      </GoogleMap>
    );
  }),
);



// WEBPACK FOOTER //
// src/modules/general/components/gMapsTrayecto.js